
import Vue from 'vue'
import Component from 'vue-class-component'

import BlueButton from '../Atomic/BlueButton.vue'
import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'
import CardTitle from '../Atomic/CardTitle.vue'

import moment from 'moment'

@Component({
  components: {
    BlueButton,
    GreenButton,
    RedButton,
    CardTitle,
  },
})
export default class DatePickerActions extends Vue {
  public picker: string = ''

  public account: any = {}
  private dialog: boolean = false
  private isPending: boolean = false
  private pickerMin: string = ''
  private maxDateAllowed: string = ''

  public show(account: any) {
    this.dialog = true
    this.account = account
    const today = moment(new Date()).format('YYYY-MM-DD')
    this.pickerMin = moment(new Date()).format('YYYY-MM-DD')
    if (
      moment(this.account.date_validite).format('YYYY-MM-DD') === '2199-07-31'
    ) {
      this.picker = moment(new Date()).format('YYYY-MM-DD')
    } else {
      if (moment(this.account.date_validite).isBefore(today)) {
        this.picker = today
      } else {
        this.picker = moment(this.account.date_validite).format('YYYY-MM-DD')
      }
    }
    this.maxDateAllowed = this.CompareDate(today)
  }

  private hide() {
    this.dialog = false
  }

  private returnData() {
    this.$emit('extend', this)
    this.hide()
  }

  private CompareDate(date: string) {
    const currentYear = moment(new Date())
    if (moment(date).isBefore(`${currentYear.format('YYYY')}-07-31`, 'month')) {
      return moment(`${currentYear.format('YYYY')}-07-31`).format('YYYY-MM-DD')
    } else {
      return moment(
        `${currentYear.add(1, 'year').format('YYYY')}-07-31`,
      ).format('YYYY-MM-DD')
    }
  }
}
